import { Environment, Store, RecordSource, Network } from 'relay-runtime';
import serverVars from 'server-vars';
import { getBuyerToken, type BuyerTokenObject } from 'dibs-cookie-jar';
import { createFetcher } from 'dibs-relay-network-layer/client.ts';
import { setupSubscriptions } from 'dibs-relay-network-layer/subscriptionsClient.ts';
import { type RecordMap } from 'relay-runtime/lib/store/RelayStoreTypes.js';

const userType = 'buyer';

export function clientRelayEnvironment(
    records?: RecordMap,
    options?: { locale: string }
): {
    environment: Environment;
    socketListeners: ReturnType<typeof setupSubscriptions>['socketListeners'];
} {
    const { locale } = options || {};
    const getQueries = (): BuyerTokenObject & { locale: string } => ({
        ...getBuyerToken(document.cookie),
        locale: locale || serverVars.get('locale'),
    });

    const { fetchOrSubscribe, socketListeners } = setupSubscriptions({
        getQueries,
        userType,
    });
    const network = Network.create(createFetcher({ getQueries, userType }), fetchOrSubscribe);
    const source = new RecordSource(records);
    const store = new Store(source);

    return {
        environment: new Environment({ network, store }),
        socketListeners,
    };
}
